if (document.querySelector('.building-specification')) {
    const buildingSpec = document.querySelector('.building-specification');

    const cardsContainer = buildingSpec.querySelector('.cards');
    const cards = buildingSpec.querySelectorAll('.card');
    const cardSpecs = buildingSpec.querySelector('.card.specifications');
    let specsHeight = cardSpecs.querySelector('.card-content').offsetHeight;
    const cardEoJ = buildingSpec.querySelector('.card.eoj');
    let eojHeight = cardEoJ.querySelector('.card-content').offsetHeight;
    const cardCerts = buildingSpec.querySelector('.card.certifications');
    let certsHeight = cardCerts.querySelector('.card-content').offsetHeight;

    let cardOpen = 0;

    //make a function which adds the "active" class to the card when the .card-toggle button is clicked
    function toggleCard(card) {
        card.querySelector('.card-toggle').addEventListener('click', () => {
            cardsContainer.classList.add('card-open');
            //add the height of the card content to the height of the card as --height



            if (cardOpen === 0) {
                cardOpen = 1;
                //remove active class from all cards
                cards.forEach(card => {
                    card.classList.remove('active');
                });
                card.classList.toggle('active');
                setTimeout(() => {
                    // if (card === cardSpecs) {
                    //     card.style.setProperty('--height', `${specsHeight}px`);
                    // } else if (card === cardEoJ) {
                    //     card.style.setProperty('--height', `${eojHeight}px`);
                    // } else if (card === cardCerts) {
                    //     card.style.setProperty('--height', `${certsHeight}px`);
                    // }
                    cardsContainer.style.setProperty('--height', `${card.querySelector('.card-inner').offsetHeight}px`);
                }, 300);



            } else { //If the card is already open, close it
                cardOpen = 0;
                card.classList.remove('active');
                cardsContainer.classList.remove('card-open');
                cardsContainer.style.removeProperty('--height');
                //remove the height of the card content from the height of the card as --height. donbt set as 0, as the transition will not work

            }

        });
    }

    toggleCard(cardSpecs);
    toggleCard(cardEoJ);
    toggleCard(cardCerts);



}